function WijmoDialogActions ( props ) {

    const { moveable, ...others } = props;
    
    return <div className="modal-footer" {...others} />;

}

export default WijmoDialogActions;
